/* MUTATION TYPES
-------------------------------------------------------------- */
export const SET_HEADER   = 'SET_HEADER';
export const SET_SIDEMENU = 'SET_SIDEMENU';
